import * as Yup from 'yup';

export const fullName = Yup.string()
  .min(3)
  .max(100);

export const email = Yup.string()
  .email();

export const dialCode = Yup.string()
  .matches(/^[0-9]+$/)
  .min(1)
  .max(7);

export const phoneNumber = Yup.string()
  .matches(/^[0-9]+$/)
  .min(4)
  .max(12);

  export const date = Yup.string()
  .matches(
    /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/
  )
export const idType = Yup.mixed()
  .oneOf(['PASSPORT','NRIC','FOREIGN_ID']);

export const passport = Yup.string()
  .matches(/^[a-zA-Z0-9]+$/)
  .min(5);

export const postcode = Yup.string()
  .matches(/^[0-9]+$/)
  .min(5)
  .max(5); //only for Malaysia

export const nric = Yup.string()
  .matches(
    /^((([[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01]))([0-9]{2})([0-9]{4}){1})$/i
  );

export const idNumber = Yup.string()
  .when('idType', { is: 'PASSPORT', then: passport })
  .when('idType', { is: 'NRIC', then: nric });

// Must contain between 6-12 alphanumeric characters, 1 uppercase and 1 special characters
export const password = Yup.string()
  .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-+_!@#$%^&*.,?])/)
  .min(6)
  .max(12);

export const gender = Yup.mixed()
  .oneOf(['MALE','FEMALE']);

export const addressLine = Yup.string()
  .max(100);

export const fullContact = Yup.object({
  dialCode: dialCode.required(),
  number: phoneNumber.required()
});
